export default __webpack_public_path__ + "static/media/wb_grid.038b7400.svg";